<template>
    <div class="grupoAgendaViewer">

        <loncheraPenalizacion ref="loncheraPenalizacion" />

        <b-card no-body>

            <div class="header-content row" slot="header">
                <div class="title col">
                    <strong>{{ selectedGrupo.grupo_clase + ' ' + selectedGrupo.grupo_titulo }}</strong>
                </div>
                <div class="diasLonchera col-tight row">
                    <div class="dia col">L</div>
                    <div class="dia col">M</div>
                    <div class="dia col">I</div>
                    <div class="dia col">J</div>
                    <div class="dia col">V</div>
                    <div class="dia col">
                        <strong>Total</strong>
                    </div>
                </div>
            </div>

            <div class="content">
                <div v-if="!alumnos.length">
                    <b-card class="bg-light p-0 pt-3 m-2 text-center">
                        <p>Elementos no encontrados</p>
                    </b-card>
                </div>
                <b-row v-for="alumno in alumnos" :key="'alumno-' + alumno.id" class="alumno-row m0" align-h="end"
                    align-v="center" no-gutters>

                    <b-col class="alumno pr-2">
                        <strong>
                            {{ alumno.nombre || loncheraSinNombre }}
                            <b-badge pill v-if="alumno.membresia == 'VIP'" variant="warning">VIP</b-badge>
                        </strong>

                        <div class="block">
                            <b-badge class="ml-1 mr-1" pill variant="dark" title="Codigo de registro"
                                v-if="alumno.codigo_registro" v-b-tooltip.hover.bottom>{{ alumno.codigo_registro
                                }}</b-badge>
                            <b-badge class="ml-1 mr-1" pill variant="danger" title="Adeudo"
                                v-if="parseFloat(alumno.monedero) < 0" v-b-tooltip.hover.bottom>{{
                                    Math.abs(alumno.monedero) | currency }}</b-badge>
                        </div>
                        <div class="block">
                            <div class="notas_alimentarias" v-if="alumno.notas_alimentarias">
                                {{ alumno.notas_alimentarias }}
                            </div>
                        </div>

                    </b-col>

                    <b-col cols="auto" class="text-right hide-on-print">
                        <b-button-group size="sm">
                            <usuario-modal :concept-id="alumno.usuario_id_pk" btn-class="btn btn-secondary">
                                <i class="fa fa-user"></i> Propietario
                            </usuario-modal>
                            <b-button variant="danger" @click="$refs.loncheraPenalizacion.penalize(alumno.id)">
                                <i class="icon icon-easylunch-sadbox confy-icon" key="icon-easylunch-sadbox"></i>
                            </b-button>
                        </b-button-group>
                    </b-col>

                    <b-col cols="auto" class="dias">
                        <dias-lonchera :edit-mode="editMode" :u-presencia-id="alumno.id"
                            :fechas="filterFechas(alumno.id)" 
                            :debug="debug" 
                            :select-filters="selectFilters"
                            @reload="$emit('reload')" />
                    </b-col>

                </b-row>
            </div>

            <div class="totals">
                <b-row class="m0" align-h="end" align-v="center" no-gutters>
                    <b-col cols="auto" class="alumno">
                        <strong>Totales</strong>
                        <!-- <br> <small>{{alumno.tipo}}</small> -->
                    </b-col>
                    <b-col cols="auto" class="dias">
                        <dias-lonchera :fechas="filterFechasAlumnos" totalizer :debug="debug"
                            @reload="$emit('reload')" />
                    </b-col>
                </b-row>
            </div>

            <div class="debug" v-if="debug">
                alumnado
                <pre>{{ alumnos }}</pre>
            </div>

            <!-- <div slot="footer">
                contadores / resumen
            </div> -->

        </b-card>

    </div>
</template>

<script>
import _ from 'lodash'
import usuarioModal from '../../Usuarios/assets/usuarioModal.vue'
import diasLonchera from './diasLonchera.vue'
import { loncheraSinNombre } from '../Easylunch'
import loncheraPenalizacion from "../elements/lonchera-penalizacion.vue";

export default {

    name: 'grupoAgendaViewer',

    components: { diasLonchera, usuarioModal, loncheraPenalizacion },

    props: {
        selectFilters: {
            type: Object
        },
        editMode: {
            type: Boolean
        },
        filterBy: {
            type: [String],
            required: true
        },
        debug: {
            type: [Boolean, Number],
            default: false
        },
        getData: {
            type: Function,
            required: true
        },
        grupoId: {
            type: [Number, String],
            required: true
        }
    },

    data: () => {
        return {
            loncheraSinNombre,
            data: {
                headers: [],
                groups: [],
                alumnos: [],
                agendaordenes: [],
            },
            alumnos: []
        }
    },

    computed: {
        selectedGrupo() {
            return _.find(this.data.groups, {
                id: this.grupoId
            })
        },
        filterFechasAlumnos() {
            return _.filter(this.data.agendaordenes, (aOrd) => {
                // console.log("aOrd", aOrd)
                // console.log("this.alumnos", this.alumnos)
                // console.log("indexOfAOrd", indexOfAOrd)
                let indexOfAOrd = _.findIndex(this.alumnos, { id: aOrd.lunch_usuariopresencia_id });
                return (indexOfAOrd !== -1)
            })
        },
    },

    methods: {
        filterFechas(alumnoId) {
            return _.filter(this.data.agendaordenes, {
                lunch_usuariopresencia_id: alumnoId
            })
        }
    },

    beforeMount() {
        this.data = this.getData()
        this.alumnos = _.filter(this.data.alumnos, {
            lunch_grupo_id: this.grupoId,
            tipo: this.filterBy
        })
    }

}
</script>

<style lang="less">
.grupoAgendaViewer {

    .row {
        margin: 0;
    }

    .col {
        align-content: center;
    }

    .card-header {
        margin: 0;
        padding: 0;
    }

    margin-bottom: 2em;

    // .diasLonchera {
        // margin: 0;
        // background: red;
        // width: calc(4.9em * 6);

        // .dia {
            // width: 5em;
            // text-align: center;
        // }
    // }

    .totals {
        color: var(--primary);
        border-top: 1px solid #c8ced3;
        background-color: #f0f3f5;
    }

    .alumno-row {
        padding: 0em 0;
        background-color: #f6f6f6;

        &:nth-child(2n+1) {
            background-color: #fff;
        }

        .alumno {
            text-align: right;
            text-transform: uppercase;
            color: #696969;
            display: inline;
            // background: green;
        }
    }
}
</style>